import styles from "./styles.scss";
import { FC, useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AvatarLoadManager, IconButton, ThemeSwitcher } from "@/components";
import { useClickOutside } from "@/hooks";
import { ExpandRight, Profile } from "@/assets/icons";
import { offset, useFloating, autoUpdate } from "@floating-ui/react";
import { BasicRoutePath } from "@/constants";
import { AuthContext } from "@/guards/auth/auth-context";
import { appConfig } from "@/guards/auth/azure-b2c.config";
import { selectUserData, useBoundStore } from "@/services/stores";
import clsx from "clsx";

export const ProfileMenu: FC = () => {
  const { logout } = useContext(AuthContext);
  const { user } = useBoundStore(selectUserData);
  const containerRef = useRef<HTMLDivElement>(null);

  const [dropdown, setDropdown] = useState({ show: false });

  const navigate = useNavigate();

  const handleMenuClick = () => toggleMenu();

  const { x, y, refs, strategy } = useFloating({
    placement: "bottom-end",
    middleware: [offset(6)],
    whileElementsMounted: autoUpdate,
  });

  const floatingStyles = {
    position: strategy,
    top: y ?? "",
    left: x ?? "",
  };

  const toggleMenu = (show?: boolean) => {
    setDropdown(prState => ({ ...prState, show: show ?? !prState.show }));
  };

  const handleClickOutside = () => {
    dropdown.show && toggleMenu(false);
  };

  useClickOutside(containerRef, handleClickOutside);

  const handleLogoutBtnClick = () => {
    if (logout) {
      logout();
    }
  };

  const handleContractorButtonClick = () => {
    toggleMenu(false);
    navigate(BasicRoutePath.ContractorProfile);
  };

  return (
    <div ref={containerRef} className={styles.profileMenu}>
      {Boolean(+appConfig?.FEATURES?.IS_DARK_THEME) && <ThemeSwitcher />}
      <div
        ref={refs.setReference}
        onClick={handleMenuClick}
        className={styles.headerAvatar}
      >
        <IconButton
          icon={Profile}
          className={clsx(
            styles.profileTrigger,
            dropdown.show && styles.active,
          )}
          iconClassName={styles.profileTriggerIcon}
        />
      </div>
      {dropdown.show && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          className={styles.profile}
        >
          <div className={styles.user}>
            <AvatarLoadManager
              name={user?.UserName}
              surname={user?.FullName}
              sourceUrl={""}
              size={44}
              className={styles.avatarContainer}
              userId={user?.Email}
            />
            <div className={styles.titles}>
              <p>{user?.FullName}</p>
              <span title={user?.Contractor.CompanyNameEn}>
                {user?.Contractor.CompanyNameEn}
              </span>
            </div>
          </div>
          <div className={styles.navList}>
            <div className={styles.item} onClick={handleContractorButtonClick}>
              <div>
                <span>Contractor Profile</span>
                <ExpandRight />
              </div>
            </div>
            <div className={styles.item} onClick={handleLogoutBtnClick}>
              <div>
                <span>Log Out</span>
                <ExpandRight />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
